import React, { FC } from 'react';
import { Divider, Paper, styled } from '@mui/material';
import { Skeleton } from '@mui/material';
import { largeCurrencyFormat } from 'common/formats/formats';
import { Currency } from 'common/types/format';
import { DEFAULT_CURRENCY, REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { formatNumbers } from 'utilities';
import { StyledDivider, StyledPaperCard, StyledSkeleton, StyledTypographyTitle, StyledTypographyValue } from './styles';
import { ValueCardProps } from './types';

export const VALUE_CARD_DEFAULT_CURRENCY = {
  code: DEFAULT_CURRENCY,
  units: REGULAR_UNIT,
} as Currency;



const ValueCard: FC<ValueCardProps> = props => {
  const { currency = VALUE_CARD_DEFAULT_CURRENCY, isLoading = false, title, value } = props;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: formatNumbers is not typed
  const formattedValue = formatNumbers({
    format: largeCurrencyFormat,
    value,
    currency,
  });

  return (
    <StyledPaperCard data-testid={`value-card-${title}`}>
      <StyledTypographyTitle>{title}</StyledTypographyTitle>

      <StyledDivider />

      {isLoading ? (
        <StyledSkeleton variant="text" />
      ) : (
        <StyledTypographyValue>{formattedValue}</StyledTypographyValue>
      )}
    </StyledPaperCard>
  );
};

export default ValueCard;
